export type CanonicalVisualKey =
  | "normal"
  | "filling"
  | "rct_open"
  | "rct_done"
  | "crown_cutting"
  | "crown"
  | "rct_cc"
  | "rct_crown"
  | "missing"
  | "implant";

const normalize = (value: unknown): string =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

const key = (value: unknown): string => normalize(value).replace(/[^a-z0-9_]+/g, "");

export function normalizeToCanonicalVisual(input: unknown): CanonicalVisualKey {
  const raw = String(input || "").trim();
  const k = key(input);

  if (
    [
      "rct_open",
      "rctopen",
      "root_canal_open",
      "rootcanalopen",
      "access_opening",
      "pulpotomy",
    ].includes(k)
  ) {
    return "rct_open";
  }
  if (
    [
      "rct_done",
      "rct_completed",
      "rctcomplete",
      "root_canal_done",
      "rootcanaldone",
      "endodontic_completed",
    ].includes(k)
  ) {
    return "rct_done";
  }
  if (["rct_crown", "rctcrown", "rct_cr", "root_canal_crown", "rootcanalcrown"].includes(k)) {
    return "rct_crown";
  }
  if (["rct_cc", "rctcc"].includes(k)) return "rct_cc";
  if (
    [
      "crown_cutting",
      "crowncutting",
      "abutment_prep",
      "abutmentprep",
      "abutment_preparation",
      "preparation_for_crown",
    ].includes(k)
  ) {
    return "crown_cutting";
  }
  if (["crown", "crowned", "bridge", "fpd", "cap"].includes(k)) return "crown";
  if (["filling", "filled", "restoration", "restorative", "composite"].includes(k)) return "filling";
  if (["missing", "extracted", "extraction", "extract", "edentulous"].includes(k)) return "missing";
  if (["implant", "implant_placed", "implantplaced"].includes(k)) return "implant";
  if (["normal", "healthy"].includes(k)) return "normal";

  if (raw === "RCT_Open") return "rct_open";
  if (raw === "RCT_Done") return "rct_done";
  if (raw === "RCT_Crown" || raw === "RCT_CROWN") return "rct_crown";
  if (raw === "RCT_CC") return "rct_cc";
  if (raw === "Crown_Cutting") return "crown_cutting";
  if (raw === "Crown") return "crown";
  if (raw === "Filling") return "filling";
  if (raw === "Missing") return "missing";
  if (raw === "Implant") return "implant";

  return "normal";
}

export function canonicalToDoctorPngState(input: unknown): string {
  const c = normalizeToCanonicalVisual(input);
  switch (c) {
    case "filling":
      return "Filling";
    case "rct_open":
      return "RCT_Open";
    case "rct_done":
      return "RCT_Done";
    case "crown_cutting":
      return "Crown_Cutting";
    case "crown":
      return "Crown";
    case "rct_cc":
      return "RCT_CC";
    case "rct_crown":
      return "RCT_Crown";
    case "missing":
      return "Missing";
    default:
      return "Normal";
  }
}

export function mapProcedureLabelToCanonicalVisual(label: unknown): CanonicalVisualKey {
  return normalizeToCanonicalVisual(label);
}
